// extracted by mini-css-extract-plugin
module.exports = {"mutedGray":"#9b9b9b","checkboxContainer":"style-module--checkboxContainer--u892c","text":"style-module--text--1lTSg"};